import { useState, useCallback } from "react";
const useDdSearch = (onSearch, onClose) => {
  const [filter, setFilter] = useState(""), handleSearch = useCallback(
    (str) => {
      setFilter(str), onSearch == null || onSearch(str);
    },
    [onSearch]
  ), handleClose = useCallback(
    (reason) => {
      onClose == null || onClose(reason), setFilter("");
    },
    [onClose, setFilter]
  );
  return { filter, onClose: handleClose, handleSearch };
};
export {
  useDdSearch
};
//# sourceMappingURL=useDdSearch.js.map
